import {Logo} from "assets";
import {BadgeIcon} from "assets/icons";
import {FC} from "react";
import {Outlet, useNavigate} from "react-router";

const ShareAppLayout: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex overflow-hidden">
      {/* Sidebar — matches CommonAppLayout sidebar */}
      <div className="h-full bg-brand-navy flex flex-col items-center py-4 flex-shrink-0 w-20 overflow-hidden">
        <Logo className="w-10 h-10 p-1.5 rounded-xl bg-brand-orange fill-white shrink-0 mb-4" />
        <div className="flex-1 min-h-0 w-full flex flex-col items-center justify-end">
          <button
            onClick={() => navigate("/auth")}
            title="Join Up"
            className="w-full flex flex-col items-center gap-1 py-2.5 px-1 rounded-xl transition-all cursor-pointer hover:bg-white/10"
          >
            <BadgeIcon className="w-5 h-5 fill-white opacity-45" />
            <span className="text-[0.625rem] font-normal text-white leading-none text-center opacity-45">Join Up</span>
          </button>
        </div>
      </div>
      <div className="h-full flex-1 min-w-0 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export default ShareAppLayout;
